export const THRESHOLD_DEFAULT = 250;

export const INITIAL_NEXT_OFFSET = 0;
export const INITIAL_TOTAL_COUNT = null;
export const DEFAULT_LIMIT = 10;
